/*** IMPORTS FROM imports-loader ***/
var define = false;

import defaultTo from 'lodash/defaultTo';
import get from 'lodash/get';
import $ from 'jquery';
import Vue from 'vue';
import debounce from 'lodash/debounce';

const bus = new Vue();

const ProductSlider = {
  template: `
    <div class="sublabel-container">
      <input type="range" 
          :min="min" 
          :max="max" 
          :step="step" 
          :value="normalizedValue" 
          @input="onInput" 
          @change="onChange">
      <div class="sublabel">{{ label }} <span class="value">({{ valueCaption }})</span></div>
    </div>
  `,
  props: {
    label: {
      type: String,
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    value: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    normalizedValue() {
      return parseInt(this.value, 10);
    },
    valueCaption() {
      return this.normalizedValue === 0 ? 'None' : `${this.normalizedValue}"`;
    },
  },
  methods: {
    onInput(ev) {
      this.$emit('input', ev.target.value);
    },
    onChange(ev) {
      this.$emit('input', ev.target.value);
    },
  },
};

const ProductFilters = {
  components: {
    ProductSlider,
  },
  props: {
    baseUrl: {
      type: String,
      required: true,
    },
    initialFilters: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    filterBounds: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  template: `
    <div class="product-filters">
      <div class="product-filter">
        <label>Width</label>
        <div class="row flush">
          <div class="small-6 columns">
            <product-slider label="Min" v-model="filter.minWidth" 
                :min="getBound('min', 'width')" 
                :max="getBound('max', 'width')" />
          </div>
          <div class="small-6 columns">
            <product-slider label="Max" v-model="filter.maxWidth" 
                :min="getBound('min', 'width')" 
                :max="getBound('max', 'width')" />
          </div>
        </div>
      </div>
      <div class="product-filter">
        <label>Height</label>
        <div class="row flush">
          <div class="small-6 columns">
            <product-slider label="Min" v-model="filter.minHeight" 
                :min="getBound('min', 'height')" 
                :max="getBound('max', 'height')" />
          </div>
          <div class="small-6 columns">
            <product-slider label="Max" v-model="filter.maxHeight" 
                :min="getBound('min', 'height')" 
                :max="getBound('max', 'height')" />
          </div>
        </div>
      </div>
      <div class="product-filter">
        <label>Depth</label>
        <div class="row flush">
          <div class="small-6 columns">
            <product-slider label="Min" v-model="filter.minDepth" 
                :min="getBound('min', 'depth')" 
                :max="getBound('max', 'depth')" />
          </div>
          <div class="small-6 columns">
            <product-slider label="Max" v-model="filter.maxDepth" 
                :min="getBound('min', 'depth')" 
                :max="getBound('max', 'depth')" />
          </div>
        </div>
      </div>
    </div>
  `,
  data() {
    return {
      filter: {
        minHeight: defaultTo(get(this.initialFilters, 'minHeight'), 0),
        maxHeight: defaultTo(get(this.initialFilters, 'maxHeight'), 0),
        minWidth: defaultTo(get(this.initialFilters, 'minWidth'), 0),
        maxWidth: defaultTo(get(this.initialFilters, 'maxWidth'), 0),
        minDepth: defaultTo(get(this.initialFilters, 'minDepth'), 0),
        maxDepth: defaultTo(get(this.initialFilters, 'maxDepth'), 0),
      },
    };
  },
  computed: {
    filterUrl() {
      let url = this.baseUrl;

      url += url.indexOf('?') === -1 ? '?' : '&';
      url += $.param(this.filter);

      return url;
    },
  },
  watch: {
    filterUrl() {
      this.loadProducts();
    },
  },
  methods: {
    getBound(minOrMax, type) {
      const minMax = minOrMax === 'min' ? 'min' : 'max';
      const propName = `${minMax}_${type}`;
      return get(this.filterBounds, propName, 0);
    },

    loadProducts: debounce(function doLoadProduct() {
      if (this.xhr) {
        this.xhr.abort();
      }

      bus.$emit('loading', true);

      $.ajax({
        type: 'GET',
        url: this.filterUrl,
      })
        .always(() => {
          bus.$emit('loading', false);
        })
        .done((html) => {
          $('.products').html(html);
        });
    }, 500),
  },
  created() {
    this.xhr = null;
  },
};

const filtersEl = document.querySelector('.js-entry-point--prodfilters');
if (filtersEl) {
  new Vue({
    el: filtersEl,
    components: {
      ProductFilters,
    },
  });
}

const loadingEl = document.querySelector('.js-entry-point--prodloading');
if (loadingEl) {
  new Vue({
    el: loadingEl,
    data: {
      loading: false,
    },
    created() {
      bus.$on('loading', (loading) => {
        this.loading = loading;
      });
    },
  });
}

$('.js-toggle-prodfilters').on('click', () => {
  $('.product-grid__filters').toggleClass('show-filters');
});

// if (Modernizr.history) {
//   const $grid = $('.product-grid');
//
//   if ($grid.length) {
//     history.replaceState({ ajaxUrl: $grid.data('first-page-url') }, '');
//   }
//
//   window.onpopstate = (ev) => {
//     if (ev.state && 'ajaxUrl' in ev.state) {
//       requestData(ev.state.ajaxUrl).then((data) => {
//         renderData(data);
//       });
//     }
//   };
// }
//
// $(document).on('click', '.product-grid__pager a[data-ajax-href]', (ev) => {
//   ev.preventDefault();
//   const $a = $(ev.currentTarget);
//   const ajaxUrl = $a.data('ajax-href');
//
//   requestData(ajaxUrl).then((data) => {
//     if (Modernizr.history) {
//       history.pushState({ ajaxUrl }, '', $a.attr('href'));
//     }
//     renderData(data);
//   });
// });

